module.exports = __webpack_public_path__ + "static/media/plus.b7647087.svg";